import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff',
    whiteSpace: 'pre-wrap'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  setPropTypes(propTypes),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    editAction,
    editConfirm,
    openApprovalProgress,
    progressOkAction,
    loading,
    resultMessage,
    detail
  }) => {
    const poorStatusArr = [
      { label: 'REVIEW', name: '審査中' }, // status post new regis
      { label: 'OK', name: '審査OK' }, // status approved, not editable
      { label: 'NG', name: '審査NG' }, // status admin refused
      { label: 'INIT', name: '登録しない' }, // status not register
      { label: 'RESUBMIT', name: '再提出依頼中' } // status admin resubmit
    ];

    const userKidStatusArr = [
      { label: 'REVIEW', name: '審査中' }, // status post new regis
      { label: 'OK', name: '審査OK' }, // status approved, not editable
      { label: 'NG', name: '審査NG' }, // status admin refused
      { label: 'RESUBMIT', name: '再提出依頼中' } // status admin resubmit
    ];

    const getPoorStatus = value => {
      let pname = '';
      poorStatusArr.forEach(element => {
        if (element.label === value) {
          pname = element.name;
        }
      });
      return pname;
    };

    const getUserKidStatus = value => {
      let pname = '';
      userKidStatusArr.forEach(element => {
        if (element.label === value) {
          pname = element.name;
        }
      });
      return pname;
    };

    return (
      <div className={classes.root}>
        <Typography variant="h6">こどもごちめし対象者書類審査</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                ①困窮者登録証明書
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {getPoorStatus(editConfirm.newPoorStatus)}
              </TableCell>
            </TableRow>
            {detail &&
              detail.userKids &&
              detail.userKids.length &&
              detail.userKids.map((item, index) => {
                return (
                  <TableRow key={`confirm-${item.userKidId}`}>
                    <TableCell className={classes.tableCellItem}>
                      {`②お子様情報と証明書${item.displayName}様`}
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {getUserKidStatus(editConfirm.userKidList[index].status)}
                    </TableCell>
                  </TableRow>
                );
              })}
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={editAction} />
        </div>
        <ProgressDialog
          openProgress={openApprovalProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
